import { render, staticRenderFns } from "./add-marks.vue?vue&type=template&id=8d8c4f6c&scoped=true&"
import script from "./add-marks.vue?vue&type=script&lang=ts&"
export * from "./add-marks.vue?vue&type=script&lang=ts&"
import style0 from "./add-marks.vue?vue&type=style&index=0&id=8d8c4f6c&lang=scss&scoped=true&"
import style1 from "./add-marks.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8c4f6c",
  null
  
)

export default component.exports